<template>
  <section class="m-content m-content-full align-items-center">
    <div class="gate_center col">
      <div class="row justify-content-center" v-if="recentTransfersP.length > 0 || dateRangeHistory !== null">
        <div class="col-12 m--margin-bottom-20">
          <div class="up-widget__title d-flex justify-content-center">
            <h2>Wallet Transactions</h2>
          </div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-7 col-md-8 col-xs-12 col-sm-12" v-if="recentTransfers.length > 0">
          <div class="m--margin-top-15">
            <rdpicker v-model="dateRangeHistory"></rdpicker>
          </div>
          <div class="airtime_list" v-if="recentTransfersF .length > 0"> 
            <div
              v-bind:key="`wallet-recentTransfers${index}`"
              class="mouse-pointer airtime_item"
              @click="onItemClicked(item)"
              v-for="(item,index) in recentTransfersP"
            >
              <div @click="onItemClicked(item)" class="left">
                <div
                  @click="onItemClicked(item)"
                  class="date"
                >{{moment(item.entryDate).format('MM/DD/YYYY')}}</div>
                <div @click="onItemClicked(item)" class="number">{{item.description}}</div>
                <div @click="onItemClicked(item)" class="network">
                  {{item.category}}
                  {{moment(item.entryDate).format('LT')}}
                </div>
              </div>
              <div @click="onItemClicked(item)" class="right">
                <div
                  @click="onItemClicked(item)"
                  class="amount"
                  :class="item.transactionType==='CREDIT'?'status-SUCCESS':'status-FAILED'"
                >
                  &#8358;{{(parseFloat(item.amount)/100).toLocaleString('en', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2})}}
                </div>
                <!-- <div class="status">{{item.externalStatus}}</div> -->
              </div>
            </div>
          </div>
          <pagination :itemPerPage="itemPerPage" :pageCount="pageCount" v-model="currentPage"></pagination>
        </div>
        <div v-if="!$store.state.Main.loading && recentTransfersF.length === 0" class="col-lg-7 col-md-8 col-xs-12 col-sm-12">
          <div class="widget not-found not-found-transactions">
            <h4 class="m--margin-top-10 text-center"><b>You haven't used your wallet yet.</b></h4>
            <div class="clear"></div>
            <div class="m--space-40"></div>
            <div class="image-not-found text-center">
              <img src="./../../../../static/media/demo/default/img/logo/logo-black.png" />
            </div>
            <div class="m--space-20"></div>
            <h5 class="text-center input--hint m--padding-30 m--margin-bottom-10">
              {{ dateRangeHistory!==null?'No transaction was performed at this time.':'When you use your Carbon wallet, your transactions will appear here.' }}
            </h5>
            <div class="widget__footer text-center m--margin-top-10 m--margin-bottom-20">
            <router-link
              :to="{ name: 'fund-wallet' }"
              class="btn btn-primary m-btn--wide"
            >Fund Wallet</router-link>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </section>
</template>

<script>
import vue from "vue";
import pagination from "../../../components/pagination.vue";
import rdpicker from "../../../components/rdpicker";
import _ from "lodash";
import { getWalletRecent } from "./../../../api/sendMoney/sendMoneyService";

export default {
  data: () => ({
    itemPerPage: 5,
    pageCount: null,
    currentPage: 1,
    dateRangeHistory: null,
    recentTransfers: []
  }),
  computed: {
    recentTransfersF: function() {
      if (this.dateRangeHistory) {
        this.currentPage = 1;
        let startDate = moment(this.dateRangeHistory.start, "YYYY/MM/DD");
        let endDate = moment(this.dateRangeHistory.end, "YYYY/MM/DD").add('days', 1);;
        return this.recentTransfers.filter(item => {
          let compareDate = moment(item.entryDate);
          return compareDate.isBetween(startDate, endDate);
        });
      } else {
        return this.recentTransfers;
      }
    },
    recentTransfersP: function() {
      this.pageCount = Math.ceil(
        this.recentTransfersF.length / this.itemPerPage
      );
      if (this.recentTransfersF.length > this.itemPerPage) {
        return this.recentTransfersF.filter((item, index) => {
          let firstItemInPage = (this.currentPage - 1) * this.itemPerPage;
          return (
            index >= firstItemInPage &&
            index < firstItemInPage + this.itemPerPage + 1
          );
        });
      } else {
        return this.recentTransfersF;
      }
    }
  },
  components: {
    rdpicker,
    pagination
  },
  mounted() {
    this.getRecentList();
  },
  methods: {
    onItemClicked(item) {
      this.$router.push({ name: "wallet-detail", params: { item: item } });
    },
    getRecentList() {
      this.$store.dispatch("loader", true);
      getWalletRecent()
        .then(response => {
          if (response.response.data !== undefined) {
            this.recentTransfers = response.response.data.content;
          }
        })
        .catch(error => {
          this.$store.dispatch("handleError", {
            response: error,
            callback: this.getRecentList,
            can_cancel: true
          });
        })
        .finally(() => {
          this.$store.dispatch("loader", false);
        });
    }
  }
};
</script>

<style>
.not-found-transactions  .image-not-found img{
  max-width: 100%;
  width: 125px;
}
.not-found-transactions h4 , .not-found-transactions h5{
  color: #8F9091;
}
</style>
